import Store from './storeStyle';
import Uplay from './uplayStyle';

const Themes = {
  Store,
  Uplay
};

export default Themes;
